import * as Sentry from '@sentry/vue';
import { type App } from 'vue';
import { type Router } from 'vue-router';
import { isProd } from '@/utils/helpers';

export const setupSentry = (app: App, router: Router) => {
  if (isProd) {
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_DSN,
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
          stickySession: true,
          // https://docs.sentry.io/platforms/javascript/guides/vue/session-replay/configuration/#mutation-limits
          mutationBreadcrumbLimit: 500,
          mutationLimit: 1500,
        }),
      ],
      // TODO: This should be its own env var
      environment: import.meta.env.MODE,
      // This sets the sample rate to be 20%
      tracesSampleRate: 0.2,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      ignoreErrors: [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Unable to preload CSS',
        'Tokens are invalid',
        'All tokens expired',
      ],
    });
  }
};

export const setSentryUser = (email: string) => {
  Sentry.setUser({ email });
};
